import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { loadTeachers } from '../../actions/userActions';
import PerformanceMetricsView from './PerformanceMetricsView';
import { GFInitialState, GFTeacherUser } from '../../models/models';

type RouterParams = {
  teacherID: string|undefined;
}

type Props = RouteComponentProps<RouterParams, {}> & {
  teacher: GFTeacherUser|undefined;
  loadTeachers: () => Promise<any>;
}

const PerformanceMetrics: React.FC<Props> = ({ params, teacher, loadTeachers }) => {
  const [isReady, setIsReady] = React.useState(false);

  useEffect(() => {
    if (!! params.teacherID && ! teacher) {
      loadTeachers().then(() => setIsReady(true));
      return;
    }

    setIsReady(true);
  }, [params.teacherID, teacher, loadTeachers]);

  if (! isReady) {
    return null;
  }

  return <PerformanceMetricsView teacher={teacher} />;
};

const mapStateToProps = (state: GFInitialState, ownProps: Props) => {
  return {
    teacher: state.groups.members.find(member => member.id === ownProps.params.teacherID),
  };
};

export default connect(mapStateToProps, {
  loadTeachers,
})(PerformanceMetrics);
